import { render, staticRenderFns } from "./proyectos-ayudas.vue?vue&type=template&id=1cca58f7"
import script from "./proyectos-ayudas.vue?vue&type=script&lang=js"
export * from "./proyectos-ayudas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports